import firebase from 'firebase/app';
import 'firebase/messaging';

const firebaseConfig = {
  apiKey: 'AIzaSyC7qpGfPsILBukDheb7zmeiOQ2jbZtxw4c',
  authDomain: 'ingenium-notification.firebaseapp.com',
  projectId: 'ingenium-notification',
  storageBucket: 'ingenium-notification.firebasestorage.app',
  messagingSenderId: '945560362081',
  appId: '1:945560362081:web:391e218927621c17d39e20',
  measurementId: 'G-KVFY3N161V',
};
// Initialize Firebase
// firebase.initializeApp(firebaseConfig);
// firebase.analytics();
let messaging = null;
if (firebase.messaging.isSupported()) {
  firebase.initializeApp(firebaseConfig);
  messaging = firebase.messaging();
} else {
  console.log('no-support :(');
}

export const getTokenn = (setTokenFound) => {
  return messaging
    ? messaging
        .getToken({
          vapidKey:
            'BMzAfbx-vCCfH_HTW27sutKHyBCbT9_uU2e6BhAKVplF3rvI2eVF3VgwrhivnRy2rUhws0vup6CCNcg8XQaAFdw',
        })
        .then((currentToken) => {
          if (currentToken) {
            console.log('current token for client: ', currentToken);
            // setTokenFound(true);

            return currentToken;

            // Track the token -> client mapping, by sending to backend server
            // show on the UI that permission is secured
          }
          console.log('No registration token available. Request permission to generate one.');
          // setTokenFound(false);
          return '';
          // shows on the UI that permission is required
        })
        .catch((err) => {
          console.log('An error occurred while retrieving token. ', err);
          // catch error while creating client token
        })
    : null;
};

export const deleteFcmTokenWeb = () => {
  return messaging
    ? messaging
        .deleteToken()
        .then(() => {
          console.log('FCM token deleted successfully.');
          return true;
        })
        .catch((err) => {
          console.log('An error occurred while deleting token. ', err);
          return false;
        })
    : null;
};

export const sibscribeToTopic = (tokensArray, topic) => {
  // These registration tokens come from the client FCM SDKs.
  fetch(`https://iid.googleapis.com/iid/v1/${tokensArray[0]}/rel/topics/priyamkhatri`, {
    method: 'POST',
    headers: {
      Authorization: `key=AAAA7eANDTo:
      APA91bFU9AgMjgZAENybLRygEvrIhLl6aTUzjTT1GcRHSjY1-wdYr0I-
      XBNDnUA63wqNcVJ2avulXI3I4F59XvQGF7G7Va_Ip84oDlrx3bLaa-j3JAlTvBzZ1pTUXjojAnpYKm4y2gT-`,
    },
    body: {
      data: {
        token: tokensArray[0],
      },
    },
  })
    .then((res) => res.json())
    .then((data) => console.log(data, 'hahahahahahahahaha'))
    .catch((err) => console.log(err, 'huhuhuhuhuhuhuhuhh'));
};

export const onMessageListener = () => {
  messaging.onMessage((payload) => {
    console.log('noti', payload);
    const notificationTitle = payload.notification.title;
    const notificationOptions = {
      body: payload.notification.body,
      icon: 'https://d1l33ng5cy7vc.cloudfront.net/Utilities/yc.png',
      image: 'https://d1l33ng5cy7vc.cloudfront.net/Utilities/yc.png',
      url: payload.data.url,
      action_name: payload.notification.action_name,
      action_url: payload.data.url,
      click_action: payload.notification.click_action,
    };

    // self.registration.showNotification(notificationTitle, notificationOptions);

    if (!('Notification' in window)) {
      console.log('This browser does not support system notifications.');
    } else if (Notification.permission === 'granted') {
      // If it's okay let's create a notification

      const notification = new Notification(notificationTitle, notificationOptions);
      notification.onclick = function (event) {
        // event.preventDefault();
        console.log('click');
        window.open(payload.data.click_action, '_blank');
        notification.close();
      };
    }
  });
};
